import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Avatar, Box, Button, Card, Container, Divider, IconButton, ListItemButton, ListItemText, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { deleteStoreFrontServiceAuth, fetchMyStorefront } from '../../services/appServices';
import { theme } from '../../theme';
import { AppBarPadding, BottomPadding } from '../../utils/helperUtils';
import LoadingComponent from '../components/LoadingComponent';
import logo from '../../assets/logo_no_text_primary.png';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from '../../context/SnackbarContext';
import ConfirmDialogComponent from '../components/ConfirmDialogComponent';

function ManageStorefrontView() {

  const { login, logout } = useAuth();
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadingFullScreen, setLoadingFullScreen] = useState(false);
  const [storefront, setStorefront] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const actionButtons = [
    {
      label: 'Edit Storefront Info',
      icon: '🔨',
      onClick: () => navigate(`/_/storefront/update/${storefront.slug}`),
      variant: 'outlined',
      color: 'white',
    },
    {
      label: 'Update Menu/Item Photos',
      icon: '📷',
      onClick: () => navigate(`/_/storefront/update/photos/items/${storefront.slug}`),
      variant: 'outlined',
      color: 'white',
    },
    {
      label: 'Update Storefront Photos',
      icon: '🖼️',
      onClick: () => navigate(`/_/storefront/update/photos/store/${storefront.slug}`),
      variant: 'outlined',
      color: 'white',
    },
    {
      label: 'Manage Permits',
      icon: '📄',
      onClick: () => navigate(`/_/storefront/manage/permits/${storefront.slug}`),
      variant: 'outlined',
      color: 'white',
    },
    {
      label: 'Delete Storefront',
      icon: '💣',
      onClick: () => {
        setDeleteDialogOpen(true)
},
      variant: 'outlined',
      color: 'white',
    },
  ];

  useEffect(() => {
    const getStorefront = async () => {
      setLoading(true);
      try {
        const response = await fetchMyStorefront(login, logout);
        if (response.success) {
          setStorefront(response.data);
        } else {
          setStorefront(null);
        }
      } catch (error) {
        setStorefront(null);
        setError(error.message)
        console.error("Error fetching storefront:", error);
      } finally {
        setLoading(false);
      }
    };

    getStorefront();

  }, [refreshKey]);

  const handleDelete = async () => {
    setLoading(true);
    try {

      const response = await deleteStoreFrontServiceAuth(storefront?.slug, login, logout);

      if (response.success) {
        showSnackbar("💣 Storefront was deleted!", "success");
        setRefreshKey(prev => prev + 1);
        // Optionally trigger UI update
      } else {
        console.error("Failed to delete storefront:", response.error);
      }
    } catch (error) {
      setError(error.message)
      console.error("Error delete storefront:", error);
    }
    finally {
      setDeleteDialogOpen(false)
      setTimeout(() => {
        setLoading(false);
      }, 3000);
    }
  }

  return (
    <Box bgcolor={theme.colors.primary}>
      <Container maxWidth="xl" className="events-box-container">
        <AppBarPadding />
        <Grid container justifyContent={'center'}>
          <Grid size={{ md: 12, lg: 6 }} width={'100%'}>
            <Typography fontSize={30} color={theme.colors.events.secondary} textAlign={'left'}>
              <Box sx={{ fontWeight: 'bold', mb: 1 }}>
                My Storefront 💎
              </Box>
            </Typography>
            <Divider sx={{ borderBottomWidth: 2, bgcolor: theme.colors.events.secondary }} />
            {
              storefront && error && (
                <Box textAlign="center" mt={4} sx={{padding: "0px 25px 0px 25px"}}>
                  <Typography color="error" variant="h6">⚠️ {error || 'Something went wrong, please try again later'}</Typography>
                </Box>
              )
            }
            {loading ? (
              <LoadingComponent fullScreen={loadingFullScreen} />
            ) : (
              <>
                {!storefront && !loading && (
                  <Box textAlign="center" mt={4}>
                    {/* <Typography variant="h6" color="white">
                      😔 You haven't created a storefront yet.
                    </Typography> */}
                    <Box justifyContent={'center'} display={'flex'} mt={5}>
                      <Button
                        // fullWidth
                        // size={'small'}
                        onClick={() => { navigate('/_/storefront/create') }}
                        variant="contained"
                        sx={{
                          // textAlign: 'left',
                          // p: 2,
                          borderRadius: 5,
                          bgcolor: theme.colors.secondary,
                          // color: 'white',
                          // justifyContent: 'flex-start',
                          gap: 1,
                        }}
                      >
                        <Typography>🤩</Typography>
                        <Typography >Create Storefront</Typography>
                      </Button>
                    </Box>
                  </Box>
                )}
                {storefront && (
                  <Grid container spacing={2} mt={2}>
                    <Grid size={{ xs: 12 }}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 5,
                          px: 2,
                          py: 1.5,
                          bgcolor: theme.colors.secondary,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: 2,
                        }}
                        elevation={1}
                      >
                        <Box display="flex" alignItems="center" gap={2}>
                          <Avatar
                            src={storefront?.logo || logo}
                            alt="Storefront Logo"
                            sx={{ width: 60, height: 60 }}
                          />
                          <Typography variant="h6" fontWeight={600} color={'white'}>
                            {storefront.name}
                          </Typography>
                        </Box>
                        <IconButton
                          component="a"
                          href={`/${storefront.slug}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{ color: 'white' }}
                        >
                          <OpenInNewIcon />
                        </IconButton>
                      </Card>
                      {/* <Divider sx={{ mt: 2, borderBottomWidth: 1, bgcolor: theme.colors.events.secondary }} /> */}

                    </Grid>
                    {actionButtons.map(({ label, icon, onClick, variant, color }, idx) => (
                      <Grid key={idx} size={{ xs: 12 }}>
                        <Button
                          fullWidth
                          onClick={onClick}
                          variant={variant}
                          sx={{
                            textAlign: 'left',
                            p: 2,
                            borderRadius: 5,
                            bgcolor: variant === 'contained' ? theme.colors.events.secondary : 'transparent',
                            borderColor: theme.colors.events.secondary,
                            color: 'white',
                            justifyContent: 'flex-start',
                            gap: 2,
                            '&:hover': {
                              bgcolor: theme.colors.events.primaryDark,
                            },
                          }}
                        >
                          <Typography fontSize="large">{icon}</Typography>
                          <Typography fontSize="large" color={color}>{label}</Typography>
                        </Button>
                      </Grid>
                    ))}
                  </Grid>
                )}
              </>
            )}
          </Grid>
        </Grid>
        {deleteDialogOpen && (
          <ConfirmDialogComponent
            dialogOpen={deleteDialogOpen}
            dialogTitle={`Are you sure you want to delete this storefront?`}
            dialogContent="This action cannot be undone. The storefront will be permanently deleted."
            primaryBtnText="Delete"
            secondaryBtnText="Cancel"
            primaryBtnBgColor={theme.colors.red}
            onSubmit={handleDelete}
            onClose={() => setDeleteDialogOpen(false)}
          />
        )}
        <BottomPadding/>
      </Container>
    </Box>
  )
}

export default ManageStorefrontView